import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ResponsiveHeader from '../components/ResponsiveHeader';
import Footer from '../components/Footer';
import { sanitizeHtml } from '../utils/sanitize';

const PrivacyPolicyPage = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const API_BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

  useEffect(() => {
    fetchPrivacyPolicy();
  }, []);

  const fetchPrivacyPolicy = async () => {
    try {
      const response = await fetch(`${API_BASE}/api/privacy-policy`);
      if (response.ok) {
        const data = await response.json();
        setContent(data.content);
      }
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <ResponsiveHeader />
      
      <main className="flex-grow bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4">
          {/* Breadcrumb */}
          <div className="mb-6">
            <Link to="/" className="text-red-700 hover:text-red-800">
              Home
            </Link>
            <span className="mx-2 text-gray-400">/</span>
            <span className="text-gray-600 dark:text-gray-400">Privacy Policy</span>
          </div>

          {/* Content */}
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-8">
            {loading ? (
              <div className="flex justify-center items-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
              </div>
            ) : (
              <div className="prose prose-lg max-w-none">
                <div 
                  className="text-gray-700 dark:text-gray-300 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}
                />
              </div>
            )}
          </div>

          {/* Last Updated Info */}
          <div className="mt-6 text-center text-sm text-gray-500">
            For questions or concerns, please contact us using the information provided above.
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
